/**
 * FT13-U28: the close evidence pack register (FSD 2.2.8.10, 2.2.8.6). Spread by
 * INT into the router; no module entitlement, like every close route.
 */

import type { RouteRecordRaw } from 'vue-router'

import { EVIDENCE_PACK_PERMISSIONS } from '@/modules/close/evidence-packs/api'

export const CLOSE_EVIDENCE_PACKS_ROUTES: RouteRecordRaw[] = [
  {
    path: '/close/evidence-packs',
    name: 'close-evidence-packs',
    component: () => import('@/modules/close/evidence-packs/EvidencePacksView.vue'),
    meta: { titleKey: 'close.ft13.routeTitles.evidencePacks', permission: EVIDENCE_PACK_PERMISSIONS.read },
  },
]
